import React from "react";
import PropTypes from "prop-types";
import HeaderTitle from "header/components/title";

const LoginHeaderTitle = () => <HeaderTitle title="Login" />;

export default LoginHeaderTitle;
